import { GridRowParams } from '@mui/x-data-grid-pro';
import { IRowAction } from '../components/query/search-result-type';

export function redirectToEntity(params: GridRowParams, rowActions: IRowAction[], resultType?: string, universe?: string): boolean {
  return redirectToEntityInternal(params, rowActions, resultType, universe, false);
}

export function redirectToRootEntity(params: GridRowParams, rowActions: IRowAction[], resultType?: string, universe?: string): boolean {
  return redirectToEntityInternal(params, rowActions, resultType, universe, true);
}

function redirectToEntityInternal(params: GridRowParams, rowActions: IRowAction[], resultType?: string, universe?: string, goToRootEntity?: boolean): boolean {
  const selection = document.getSelection() as any;
  const { row } = params;

  const { baseOffset, extentOffset } = selection;
  const hasTextSelected = baseOffset !== extentOffset;
  const resultTypeOrUniverse = goToRootEntity ? universe : resultType ?? universe;
  const rowAction =
    rowActions &&
    resultTypeOrUniverse !== undefined &&
    rowActions.find(x => {
      const resultTypeMatch = x.resultType.toLowerCase() === resultTypeOrUniverse.toLowerCase();
      if (!resultTypeMatch) return false;

      // Also filter on universe if provided
      if (universe !== undefined && x.universe !== undefined) {
        return x.universe.toLowerCase() === universe.toLowerCase();
      }

      return true;
    });

  if (row?.id && row.id.toString().startsWith('00000000-0000-0000-0000-')) {
    return false;
  }
  const goToId = goToRootEntity ? row.rootEntityId : row.id;

  if (rowAction && rowAction.url && !hasTextSelected) {
    const url = rowAction.url
      .replace('{record.guid}', goToId || '')
      .replace('{ticks}', new Date().getTime().toString())
      .replace('{rootEntityId}', row.rootEntityId || '');
    if (rowAction.openNewWindow) {
      window.open(url, rowAction.resultType + goToId);
    } else {
      window.location.assign(url);
    }
  }
  return true;
}
